import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";

/**
 * Live community metrics with founding-member + 90-day-goal framing.
 * Replaces the old static "500+ businesses / 10K+ products / 50K+ community"
 * tiles so the homepage reflects where we actually are on the journey.
 */
export default function CommunityStats() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/community/stats`)
      .then((r) => !cancelled && setStats(r.data))
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  // While loading, render skeleton placeholders so layout doesn't jump.
  const total = stats?.total_businesses ?? "—";
  const founding = stats?.founding_members ?? "—";
  const foundingGoal = stats?.founding_member_goal ?? 100;
  const ninetyDayGoal = stats?.ninety_day_goal_new_businesses ?? 90;
  const ninetyDayTarget = stats?.ninety_day_target_total ?? "—";

  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-4"
      data-testid="community-stats"
    >
      <div className="animate-fadeIn stagger-1 opacity-0">
        <p
          className="text-3xl font-heading text-tbc-navy"
          data-testid="stat-businesses"
        >
          {total}
        </p>
        <p className="text-sm text-gray-600 font-body">
          Black-owned businesses
        </p>
      </div>

      <div className="animate-fadeIn stagger-2 opacity-0">
        <p
          className="text-3xl font-heading text-tbc-navy"
          data-testid="stat-founding"
        >
          {founding}
          <span className="text-gray-400 text-xl"> / {foundingGoal}</span>
        </p>
        <p className="text-sm text-gray-600 font-body">
          Founding members claimed
        </p>
      </div>

      <div className="animate-fadeIn stagger-3 opacity-0">
        <p
          className="text-3xl font-heading text-tbc-navy"
          data-testid="stat-90day"
        >
          +{ninetyDayGoal}
        </p>
        <p className="text-sm text-gray-600 font-body">
          Goal in the next 90 days
          {ninetyDayTarget !== "—" && (
            <span className="text-gray-400"> · target {ninetyDayTarget}</span>
          )}
        </p>
      </div>
    </div>
  );
}
